<template>
  <font-awesome-icon
    icon="unlink"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUnlink } from '@fortawesome/free-solid-svg-icons'

library.add(faUnlink)

export default {
  name: 'CoozzyUnlinkIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
